import logger from './logger'

/**
 * Cache simples para imagens carregadas
 * Evita recarregar a mesma imagem múltiplas vezes
 */
class ImageCache {
  constructor() {
    this.cache = new Map()
    this.maxSize = 50 // Limite de imagens em cache
  }

  /**
   * Carrega uma imagem e armazena em cache
   * @param {string} url - URL da imagem
   * @returns {Promise<boolean>} - true se carregou com sucesso, false se falhou
   */
  loadImage(url) {
    if (!url) {
      return Promise.resolve(false)
    }

    // Se já está em cache, retorna o resultado armazenado
    if (this.cache.has(url)) {
      return Promise.resolve(this.cache.get(url))
    }

    // Remove a entrada mais antiga se atingir o limite
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value
      this.cache.delete(firstKey)
    }

    return new Promise((resolve) => {
      const img = new Image()
      
      img.onload = () => {
        this.cache.set(url, true)
        resolve(true)
      }
      
      img.onerror = () => {
        this.cache.set(url, false)
        logger.error('Erro ao carregar imagem:', url)
        resolve(false)
      }
      
      img.src = url
    })
  }

  /**
   * Verifica se uma imagem está em cache
   * @param {string} url - URL da imagem
   * @returns {boolean|null} - true/false se está em cache, null se não está
   */
  isInCache(url) {
    return this.cache.has(url) ? this.cache.get(url) : null
  }

  /**
   * Limpa o cache
   */
  clear() {
    this.cache.clear()
  }

  /**
   * Remove uma URL específica do cache
   * @param {string} url - URL da imagem
   */
  remove(url) {
    this.cache.delete(url)
  }
}

// Exporta uma instância singleton
export default new ImageCache()
